import React from "react";
import { OnboardingForm } from "../components/OnboardingForm";

const OnboardingPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <h1 className="text-3xl font-bold text-gray-900 text-left">
            Customer Onboarding
          </h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-12">
        <div className="flex justify-center items-center">
          <OnboardingForm />
        </div>
      </main>
    </div>
  );
};

export default OnboardingPage;
